import {TabItem} from "./tab-item";

export class CodeNameChartTabs {
    constructor(public readonly GUID: string, public tabs: TabItem[]) {
        this.selected = [];
        this.viewMode = null;
    }

    public viewMode: number;
    public selected: TabItem[];

    public clone = (): CodeNameChartTabs => {
        let clone = new CodeNameChartTabs(this.GUID, this.tabs.map(item => item.clone()));
        clone.viewMode = this.viewMode;
        clone.selected = this.selected.map(item => item && item.clone());
        return clone;
    }

}

export class MenuChartTabs {
    constructor(public readonly tab?: TabItem, public readonly group?: string, public readonly groupId?: string, public readonly tabs?: TabItem[] ) {
        this.selected = [];
        this.viewMode = null;
    }

    public viewMode: number;
    public selected: TabItem[];

    public clone = (): MenuChartTabs => {
        let clone = new MenuChartTabs(this.tab ? this.tab.clone() : null, this.group, this.groupId, this.tabs && this.tabs.length ? this.tabs.map(item => item.clone()) : null);
        clone.viewMode = this.viewMode;
        clone.selected = this.selected.map(item => item.clone());
        return clone;
    }

}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/code-name-chart-tabs.ts